export const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(value)
}

export const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    // Get UTC components
    const year = date.getUTCFullYear()
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const day = String(date.getUTCDate()).padStart(2, '0')
    return `${month}/${day}/${year}`
}

export const calculateCollectionRate = (
    total_amount: number,
    total_paid: number,
) => {
    return (total_paid / total_amount) * 100
}

/**
 * Calculates the average collection rate across all months in the PaymentTrends object.
 * For each month, collection rate = (total_paid / total_invoiced) * 100
 * Returns the average of these rates (ignoring months with total_invoiced = 0).
 */
export function calculateAverageCollectionRate(paymentTrends: {
    [month: string]: { total_paid: number; total_invoiced: number }
}): number {
    // Get current month in 'YYYY-MM' format
    const now = new Date()
    const currentMonth = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
    ).padStart(2, '0')}`
    const rates: number[] = Object.entries(paymentTrends)
        .filter(
            ([month, { total_invoiced }]) =>
                month !== currentMonth && total_invoiced > 0,
        )
        .map(
            ([, { total_paid, total_invoiced }]) =>
                (total_paid / total_invoiced) * 100,
        )
    if (rates.length === 0) return 0
    const sum = rates.reduce((acc, rate) => acc + rate, 0)
    return sum / rates.length
}
